import { render } from "./SeguimientoPedidos.vue?vue&type=template&id=71321337&scoped=true"
import script from "./SeguimientoPedidos.vue?vue&type=script&lang=js"
export * from "./SeguimientoPedidos.vue?vue&type=script&lang=js"

import "./SeguimientoPedidos.vue?vue&type=style&index=0&id=71321337&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71321337"]])

export default __exports__